<grid-accordion [ngClass]="{ 'dark-accordion': accordion.isOpen }" [inverseColor]="accordion.isOpen" #accordion>
  <span slot="title">{{ sectionTitle | uppercase }}</span>
  <div slot="body" class="accordion-section-container">
    <form [formGroup]="accordionDataForm">
      <div id="sivi-section" *ngIf="sectionTitle === 'sivi'">
        <div class="header">
          <h2 class="red-heading" translate>DASHBOARD.DETAILED-DATA.VEHICLE-DEATILS</h2>
          <div class="select-container">
            <grid-dropdown
              class="dropdown-config--input_full"
              [options]="accordionDropConfig.options"
              option-label="label"
              option-value="value"
              [id]="accordionDropConfig.formControlName"
              [placeholder]="accordionDropConfig.placeholder"
              [gridDisabled]="!dropDownOptionsArray"
              isPositionAbsolute="true"
              (valueChange)="setValue($event, accordionDropConfig.formControlName)"
              [value]="accordionDropConfig.form.get(accordionDropConfig.formControlName)?.value">
            </grid-dropdown>
          </div>
        </div>
        <div class="body">
          <h2 class="black-heading" translate>DASHBOARD.DETAILED-DATA.EMISSION-DETAILS</h2>
          <div class="data-container">
            <div class="identity-data" *ngFor="let sectionRow of siviSectionRows; index as i">
              <ng-container
                [ngTemplateOutlet]="singleDataSlot"
                [ngTemplateOutletContext]="{ i: i, sectionRow: sectionRow, sectionRows: siviSectionRows }"></ng-container>
            </div>
          </div>
        </div>
      </div>

      <div class="sita-section" *ngIf="sectionTitle === 'sita'">
        <div class="header">
          <h2 class="red-heading" translate>DASHBOARD.DETAILED-DATA.COVERAGE-DATA-DETAILS</h2>
          <div class="select-container">
            <grid-dropdown
              class="dropdown-config--input_full"
              [options]="accordionDropConfig.options"
              option-label="label"
              option-value="value"
              [id]="accordionDropConfig.formControlName"
              [placeholder]="accordionDropConfig.placeholder"
              [gridDisabled]="!dropDownOptionsArray"
              isPositionAbsolute="true"
              (valueChange)="setValue($event, accordionDropConfig.formControlName)"
              [value]="accordionDropConfig.form.get(accordionDropConfig.formControlName)?.value">
            </grid-dropdown>
          </div>
        </div>
        <div class="body">
          <h2 class="black-heading" translate>DASHBOARD.DETAILED-DATA.BUSINESS-DETAILS</h2>
          <div class="data-container">
            <div class="identity-data" *ngFor="let sectionRow of sitaBusinessDetailsRows; index as i">
              <ng-container [ngTemplateOutlet]="singleDataSlot" [ngTemplateOutletContext]="{ i: i, sectionRow: sectionRow, sectionRows: sitaBusinessDetailsRows }"></ng-container>
            </div>
          </div>
          <h2 class="black-heading" translate>DASHBOARD.DETAILED-DATA.COVERAGE-DETAILS</h2>
          <div class="data-container">
            <div class="identity-data" *ngFor="let sectionRow of sitaCoverageDetailsRows; index as i">
              <ng-container [ngTemplateOutlet]="singleDataSlot" [ngTemplateOutletContext]="{ i: i, sectionRow: sectionRow, sectionRows: sitaCoverageDetailsRows }"></ng-container>
            </div>
          </div>
        </div>
      </div>

      <div class="atrc-section" *ngIf="sectionTitle === 'atrc'">
        <div class="header">
          <h2 class="red-heading" translate>DASHBOARD.DETAILED-DATA.DETAILED-ATTESTATION-DATA</h2>
          <div class="select-container">
            <grid-dropdown
              class="dropdown-config--input_full"
              [options]="accordionDropConfig.options"
              option-label="label"
              option-value="value"
              [id]="accordionDropConfig.formControlName"
              [placeholder]="accordionDropConfig.placeholder"
              [gridDisabled]="!dropDownOptionsArray"
              isPositionAbsolute="true"
              (valueChange)="setValue($event, accordionDropConfig.formControlName)"
              [value]="accordionDropConfig.form.get(accordionDropConfig.formControlName)?.value">
            </grid-dropdown>
          </div>
        </div>

        <div class="body">
          <h2 class="black-heading" translate>DASHBOARD.DETAILED-DATA.RISK-STATUS-CERTIFICATE</h2>
          <div class="data-container">
            <div class="identity-data" *ngFor="let sectionRow of atrcSectionRows; index as i">
              <ng-container [ngTemplateOutlet]="singleDataSlot" [ngTemplateOutletContext]="{ i: i, sectionRow: sectionRow, sectionRows: atrcSectionRows }"></ng-container>
            </div>
            <hr />
            <div class="identity-data">
              <h2 class="black-heading" translate>DASHBOARD.DETAILED-DATA.ATTESTED-CLAIM-DETAILS</h2>
              <div class="table-container">
                <grid-table [columns]="columns" [rows]="rows"></grid-table>
              </div>
            </div>
          </div>
        </div>
      </div>
    </form>
  </div>
</grid-accordion>

<ng-template #singleDataSlot let-i="i" let-sectionRow="sectionRow" let-sectionRows="sectionRows" let-sectionItem="sectionItem">
  <div class="data-slot">
    <h3 class="black-heading" *ngIf="sectionRow.title" translate>
      <span *ngIf="!sectionRow.titleValue">
        <span *ngIf="!sectionRow.number" translate>DASHBOARD.DETAILED-DATA.{{ sectionRow.title }}</span>
        <span *ngIf="sectionRow.number" >
          <span translate>DASHBOARD.DETAILED-DATA.{{ sectionRow.title }}</span>
          <span> {{sectionRow.number}}</span>
        </span>
      </span>
      <span *ngIf="sectionRow.titleValue">
        <span translate>DASHBOARD.DETAILED-DATA.{{ sectionRow.title }}</span
        >:
        <span class="key"> {{ sectionData.accordionData[sectionRow.titleValue] || '-' }}</span>
      </span>
    </h3>
    <div class="detail-data-container" *ngFor="let section of sectionRow.data">
      <app-static-accordion-data [sectionTitle]="sectionTitle" [sectionData]="sectionData.accordionData" [singleRow]="section"></app-static-accordion-data>
    </div>
    <hr *ngIf="i < sectionRows.length - 1"/>
  </div>
</ng-template>


<grid-modal showCloseButton="false" #modal [isOpen]="openModal">
  <div slot="title" class="modal-title flex-space-between">
    <h2 translate>DASHBOARD.POP-UP.ATTENTION</h2>
    <grid-button
      icon="right"
      variant="tertiary-ghost"
      (click)="openModal = false"
    >
      <grid-icon slot="icon" name="close" color="grid-action-primary" size="l" />
    </grid-button>
  </div>
  <div slot="body" class="modal-body">
    <div class="errors-container" *ngFor ="let errorMessage of errorMessages">
      <p>
        <span class="strong">ERRORE SERVIZIO {{errorMessage.section | uppercase}} </span>
        <span *ngFor = "let message of errorMessage.messages; index as i">
          <span>{{message.codice && message.descrizione ? message.codice + ' ' + message.descrizione : message}}</span>
          <span *ngIf = "i < errorMessage.messages.length-1">,</span>
        </span>
      </p>
    </div>
  </div>
  <div slot="button-primary" class="button-box">
    <grid-button variant="secondary" (click)="openModal = false" translate
      >DASHBOARD.BUTTONS.OK</grid-button
    >
  </div>
</grid-modal>
